export { MobileLayout } from "@/components/layout/MobileLayout/MobileLayout";
export { MobileBottomNav } from "@/components/layout/MobileLayout/MobileBottomNav";
export type { MobileLayoutProps, NavItem } from "@/components/layout/MobileLayout/MobileLayout.types";

import { withAuth } from "@/hoc/withAuth";
import { withPublicAuth } from "@/hoc/withPublicAuth";
import { MobileLayout } from "@/components/layout/MobileLayout/MobileLayout";
import { MockExamMobileLayout } from "@/components/layout/MobileLayout/MockExamMobileLayout";

export const MobileLayoutWithAuth = withAuth(({ isLoading }) => <MobileLayout bottomNav isLoading={isLoading} />, { delegateLoading: true });

export const MockExamMobileLayoutWithAuth = withAuth(({ isLoading }) => <MockExamMobileLayout bottomNav isLoading={isLoading} />, {
  delegateLoading: true,
});

export const MobileLayoutPublic = () => <MobileLayout />;

export const MobileLayoutPublicAuth = withPublicAuth(() => <MobileLayout />);
